import React from 'react';
import styles from './Sidebar.module.css';
import { IconButton, Tooltip } from '@mui/material';
import { IoClose, IoAdd } from 'react-icons/io5';

const Sidebar = ({ isOpen, onClose, title, children, position = 'right', onNewConversation }) => {
  if (!isOpen) return null;

  // Handler for overlay clicks - will close the sidebar
  const handleOverlayClick = (e) => {
    // Only close if the click was directly on the overlay (not on its children)
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.sidebarOverlay} onClick={handleOverlayClick}>
      <div className={`${styles.sidebar} ${position === 'left' ? styles.leftPosition : ''}`}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.headerButtons}>
            {title === "Conversation History" && onNewConversation && (
              <Tooltip title="New Conversation">
                <IconButton 
                  onClick={onNewConversation}
                  className={styles.newConversationButton}
                  size="small"
                >
                  <IoAdd size={20} />
                </IconButton>
              </Tooltip>
            )}
            <IconButton 
              onClick={onClose}
              className={styles.closeButton}
              size="small"
            >
              <IoClose size={20} />
            </IconButton>
          </div>
        </div>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
